import i18n from "@/helpers/i18n";

export const getRole: any = function (role: string) {
    switch (role) {
        case 'owner':
            return i18n.t('common.roles.owner')
            break;
        case 'marketer':
            return i18n.t('common.roles.marketer')
            break;
        case 'standman':
            return i18n.t('common.roles.standman')
            break;
    }

}